import React from 'react'

export const BellWithBackgroundIcon: React.FC = () => (
  <svg width="48" height="48">
    <g fill="none" fillRule="evenodd">
      <rect width="48" height="48" fill="#FE812E" rx="16" />
      <path
        d="M28.939 31.9c.611 1.393-.022 3.02-1.417 3.63-1.393.612-3.018-.022-3.629-1.416-.164-.372-.231-.761-.226-1.144l4.583-2.01c.284.253.524.567.689.94zm-14.153-7.283c-1.293-3.253-.635-6.354 1.298-8.382-.08-.122-.16-.236-.22-.376-.612-1.393.022-3.016 1.415-3.627 1.394-.612 3.019.024 3.631 1.418.058.131.09.268.124.403 2.896-.058 5.755 1.706 7.25 4.705 0 0 2.212 5.08 4.642 5.484.076.004 1.379.037 1.777.987.375.899-.397 2.102-1.74 2.68L18.42 34.175c-1.341.578-2.823.346-3.14-.574-.313-.906.374-1.75.439-1.824 1.373-2.11-.933-7.16-.933-7.16z"
        fill="#F6F5F4"
        fillRule="nonzero"
      />
    </g>
  </svg>
)
